// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__18KGa","question":"Question_question__2zzdF","description":"Question_description__1DBex"};